<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="network-wired"/>
          API Hilo
        </h1>
      </div>
    </div>
    <hilo-invoice-log-list/>
  </main>
</template>

<script>
import HiloInvoiceLogList from "@/views/vat-invoice/HiloInvoiceLogList.vue";

export default {
  components: {HiloInvoiceLogList},
  data() {
    return {}
  }
}
</script>